import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

type ImportFactory<T extends ComponentType<any>> = () => Promise<{ default: T }>;

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.name === 'ChunkLoadError' ||
    /Loading chunk .* failed/i.test(error.message) ||
    /Loading CSS chunk .* failed/i.test(error.message)
  );
}

/** 懒加载失败（常见于 HMR/发版后 chunk 哈希变化）时自动刷新一次页面 */
export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: ImportFactory<T>,
  chunkName: string,
): LazyExoticComponent<T> {
  return lazy(async () => {
    const retryKey = `chunk-retry:${chunkName}`;
    try {
      const mod = await componentImport();
      sessionStorage.removeItem(retryKey);
      return mod;
    } catch (error) {
      if (isChunkLoadError(error) && !sessionStorage.getItem(retryKey)) {
        sessionStorage.setItem(retryKey, '1');
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
